//@ts-nocheck
import {
  applySnapshot,
  flow,
  getEnv,
  getSnapshot,
  types,
} from "mobx-state-tree";
import { TutorJobListStore } from "./jobs";
import { ResponseType } from "../adapter";
import { AgreementStore } from "./agreement";
import {
  ClientPageTypes,
  ClientSubjectType,
  CLIENT_PAGES,
} from "./client-types";
import { EducationWorkHistoryStore } from "./educationWork";
import { IdentityStore } from "./identity";
import { LocationFieldStore } from "./location";
import { OtherStore } from "./other-store";
import { PaymentInfoStore } from "./paymentInfo";
import { defaultPersonalInfo, PersonalInfoStore } from "./personal-info";
import { ScheduleStore } from "./schedule";
import { SubjectStore } from "./subject";
import { TeachingProfileStore } from "./teaching-profile";
import { FactorStore } from "./factor";
import { STEPS } from "./utils";
export { STEPS };
export type FormStepType =
  | "personal-info"
  | "password-info"
  | "location-info"
  | "education-history"
  | "work-history"
  | "subject-selection"
  | "verification-info"
  | "schedule-info"
  | "agreement-info"
  | "new-development-info"
  | "guarantors-info"
  | "teaching-profile"
  | "payment-info";

export const APPLICATION_STEPS = {
  APPLY: "apply",
  VERIFY: "verify",
  SUBJECT: "subjects",
  COMPLETE: "complete",
  TUTOR_PREFERENCES: "preferences",
  TERMS: "terms",
  VERIFIED_TUTOR: "application-verified",
};
export const RootStore:any = types
  .model("RootTutorStore", {
    jobs: types.optional(TutorJobListStore, {}),
    educationWorkHistory: types.optional(EducationWorkHistoryStore, {}),
    locationInfo: types.optional(LocationFieldStore, {}),
    identity: types.optional(IdentityStore, {}),
    personalInfo: types.optional(PersonalInfoStore, defaultPersonalInfo),
    schedule: types.optional(ScheduleStore, {}),
    agreement: types.optional(AgreementStore, {}),
    paymentInfo: types.optional(PaymentInfoStore, {}),
    subject: types.optional(SubjectStore, {}),
    teachingProfile: types.optional(TeachingProfileStore, {}),
    others: types.optional(OtherStore, {}),
    loading: types.optional(types.boolean, false),
    userIsloggedIn: types.optional(types.boolean, false),
    slug: types.optional(types.string, ""),
    currentEditableForm: types.optional(types.string, STEPS.PERSONAL_INFO),
    emailVerified: types.optional(types.boolean, false),
    isEditAction: types.optional(types.boolean, false),
    applicationLoading: types.optional(types.boolean, false),
    currentStep: types.optional(types.string, APPLICATION_STEPS.APPLY),
    editIndex: types.optional(types.string, ""),
    factors: types.optional(FactorStore, {}),
    unique_clients: types.optional(types.number, 0),
    ratings: types.optional(types.number, 0),
    dateSubmitted: types.optional(types.string, ""),
    cloudinaryName: types.optional(types.string, "tuteria"),
  })
  .views((self) => {
    return {
      get cloudinaryProps() {
        return {
          cloudName: self.cloudinaryName,
          uploadPreset: "video-submission",
          publicId: `${self.slug}-video`,
        };
      },
      get verificationStepsWithError() {
        let errors = [];
        if (!self.identity.profileUploaded) {
          errors.push("Upload a profile photo");
        }
        if (!self.identity.idUploaded) {
          errors.push("Upload a valid ID");
        }
        if (!self.others.videoSummary.completed) {
          errors.push("Submit a video introduction");
        }

        return errors;
      },
      get applyStepsWithError() {
        const errors = [];
        if (!self.personalInfo.completed) {
          errors.push("Complete your personal info");
        }
        if (!self.educationWorkHistory.educationCompleted) {
          errors.push("Provide your education history");
        }
        if (!self.locationInfo.completed) {
          errors.push("Update your tutoring location");
        }

        return errors;
      },
      get preferenceStepsWithError() {
        const errors = [];
        if (!self.schedule.completed) {
          errors.push("Update your availability");
        }
        if (!self.paymentInfo.completed) {
          errors.push("Provide your payment information");
        }

        return errors;
      },
      get termsStepsWithError() {
        const errors = [];
        if (self.educationWorkHistory.guarantors.length !== 2) {
          errors.push("Provide 2 references");
        }
        if (!self.emailVerified) {
          errors.push("Verify your email address");
        }
        if (!self.others.newDevelopment) {
          errors.push("Ensure that you agree to the tutoring process");
        }
        if (!self.agreement.completed) {
          errors.push("Ensure that you agree to the terms and agreement");
        }

        return errors;
      },
      get postApplicationStepsWithError() {
        const errors = [];
        if (!self.locationInfo.completed) {
          errors.push("Update your tutoring location");
        }
        if (!self.schedule.completed) {
          errors.push("Update your availability");
        }
        if (!self.paymentInfo.completed) {
          errors.push("Provide your payment information");
        }
        return errors;
      },
      get postApplication2StepsWithError() {
        const errors = [];
        if (self.educationWorkHistory.guarantors.length !== 2) {
          errors.push("Provide 2 references");
        }
        if (!self.others.newDevelopment) {
          errors.push("Ensure that you agree to the tutoring process");
        }
        if (!self.agreement.completed) {
          errors.push("Ensure that you agree to the terms and agreement");
        }
        if (!self.emailVerified) {
          errors.push("Verify your email address");
        }
        return errors;
      },
      get populateRequiredSubjectsErrors() {
        const errors: string[] = [];
        self.subject.subjectsRequiredForJob.forEach((subject: any) => {
          if (!["active", "pending"].includes(subject.status)) {
            errors.push(`Take action on ${subject.name}`);
          }
        });
        return errors;
      },
      get priceFactor() {
        let priceFactor =
          self.locationInfo.factor *
          self.educationWorkHistory.maxEducationFactor *
          this.tutorLevelFactor *
          this.ratingsFactor *
          this.noOfClientsFactor *
          this.experienceFactor;
        return priceFactor;
      },
      get tutorLevelFactor() {
        let found = self.factors.tutorLevelFactor.find(
          (item) =>
            item.tutor_level.toLowerCase() === self.others.level.toLowerCase()
        );
        return found?.factor || 1;
      },
      get ratingsFactor() {
        let rating = "No rating";
        if (self.ratings > 0 && self.ratings < 4) {
          rating = "Below 4.0";
        } else if (self.ratings >= 4 && self.ratings <= 4.2) {
          rating = "4.0 - 4.2";
        } else if (self.ratings >= 4.3 && self.ratings <= 4.7) {
          rating = "4.3 - 4.7";
        } else if (self.ratings >= 4.8 && self.ratings <= 5.0) {
          rating = "4.8 - 5.0";
        }
        const foundRatings = self.factors.ratingsFactor.find(
          (item) => item.ratings === rating
        );
        return foundRatings?.factor || 1;
      },
      get noOfClientsFactor() {
        let uniqueClients = "None";
        if (self.unique_clients > 0 && self.unique_clients < 5) {
          uniqueClients = "Less than 5";
        } else if (self.unique_clients >= 5 && self.unique_clients < 10) {
          uniqueClients = "Btw 5 & 10";
        } else if (self.unique_clients >= 10 && self.unique_clients < 20) {
          uniqueClients = "Btw 10 & 20";
        } else if (self.unique_clients >= 20) {
          uniqueClients = "More than 20";
        }
        const foundUniqueClients = self.factors.noOfClientsFactor.find(
          (item) =>
            item.no_of_clients.toLowerCase() === uniqueClients.toLowerCase()
        );
        return foundUniqueClients?.factor || 1;
      },
      get experienceFactor() {
        let factorKey = "None";
        let experience = self.educationWorkHistory.totalWorkExperience;
        if (experience > 0 && experience < 5) {
          factorKey = "Below 5";
        } else if (experience >= 5 && experience <= 10) {
          factorKey = "Btw 5 & 10";
        } else if (experience > 10) {
          factorKey = "Above 10";
        }
        const foundExperience = self.factors.experienceFactor.find(
          (item) => item.experience === factorKey
        );
        return foundExperience?.factor || 1;
      },
      getPriceSuggestion(subject: any) {
        let tuteriaSubject = self.subject.tuteriaSubjects.find(
          (item) => item.name === subject.name
        );
        const result: any = {};
        let _self = this || self;
        let recommendedRate =
          _self.priceFactor * (tuteriaSubject?.baseRate || 1000);
        self.factors.recommendedFactor.forEach((item) => {
          if (item.name.toLowerCase() === "recommended") {
            result.recommended =
              Math.ceil((item.factor * recommendedRate) / 10) * 10;
          }
          if (item.name.toLowerCase() === "minimum") {
            result.minimum =
              Math.ceil((item.factor * recommendedRate) / 10) * 10;
          }
          if (item.name.toLowerCase() === "maximum") {
            result.maximum =
              Math.ceil((item.factor * recommendedRate) / 10) * 10;
          }
        });
        console.log(result);
        return result;
      },
      get level() {
        return self.others.premium ? "premium" : "regular";
      },
      get supportedCountryData() {
        return self.locationInfo.countriesSupported.find(
          (o) => o.name === self.locationInfo.supportedCountryAccount
        );
      },
      get completed() {
        // this needs to be changed
        return (
          self.personalInfo.completed &&
          self.locationInfo.completed &&
          self.identity.completed &&
          self.schedule.completed &&
          self.paymentInfo.completed &&
          self.educationWorkHistory.completed &&
          self.agreement.completed &&
          self.schedule.completed
        );
      },
      get isEmptyForms() {
        return !self.others.canApply;
      },
      get jobTutorInfo() {
        return {
          userId: self.slug,
          firstName: self.personalInfo.firstName,
          lastName: self.personalInfo.lastName,
          delivery: self.locationInfo.lessonType,
          level: this.level,
          photo: self.identity.profilePhoto,
        };
      },
    };
  })
  .actions((self) => {
    let { adapter } = getEnv(self);
    function initializeClientTutorData(key: string, data: ClientPageTypes) {
      if (key === CLIENT_PAGES.JOBS) {
        applySnapshot(self, {
          personalInfo: {
            ...data.tutorInfo.personalInfo,
          },
        });
        self.jobs.bulkMapToStore(data.jobs);
      }
      if (key === CLIENT_PAGES.COMPLETE_ONBOARDING) {
      }
      if (key === CLIENT_PAGES.SUBJECTS) {
        let { tutorInfo: tutor_data, subjectData, staticData } = data;
        applySnapshot(self, {
          personalInfo: tutor_data.personalInfo,
          locationInfo: {
            ...tutor_data.personalInfo,
            regions: staticData.regions,
          },
          educationWorkHistory: { ...tutor_data.educationWorkHistory },
          others: {
            ...(tutor_data.others || {}),
            isDeluxe:
              tutor_data.others?.isDeluxe ||
              tutor_data.level?.toLowerCase() == "deluxe" ||
              false,
            inProbation:
              tutor_data.others?.inProbation ||
              tutor_data.level?.toLowerCase() == "probation" ||
              false,
            premium:
              tutor_data.others?.premium ||
              tutor_data.level?.toLowerCase() == "premium" ||
              false,
          },
          factors: staticData.pricing || {},
          unique_clients: tutor_data?.unique_clients,
          ratings: tutor_data?.ratings,
        });
        if (subjectData) {
          self.subject.initializeTutorSubjects(subjectData);
        }
        self.educationWorkHistory.updateEducationData(staticData.educationData);
      }
      if (key === CLIENT_PAGES.PERSONAL_INFO) {
        let { staticData, tutorInfo: tutor_data } = data;
        let { regions, countries, educationData } = staticData;
        applySnapshot(self, {
          personalInfo: {
            ...tutor_data.personalInfo,
            nationality: tutor_data.personalInfo?.country,
            subscription: tutor_data?.appData?.receiveJobs || undefined,
          },
          identity: tutor_data?.identity,
          locationInfo: {
            countries,
            regions,
            supportedCountryAccount:
              tutor_data?.paymentInfo?.country ||
              tutor_data.personalInfo?.locationCountry,
            state: tutor_data.personalInfo?.state,
            country: tutor_data.personalInfo?.locationCountry,
            region: tutor_data.personalInfo?.region,
            vicinity: tutor_data.personalInfo?.vicinity,
            address: tutor_data.personalInfo?.address,
          },
        });
        self.educationWorkHistory.updateEducationData(educationData);
      }
      if (key === CLIENT_PAGES.LOCATION_INFO) {
        let { staticData, tutorInfo: tutor_data } = data;
        let { regions, countries, supportedCountries } = staticData;
        applySnapshot(self, {
          personalInfo: {
            ...tutor_data.personalInfo,
          },
          locationInfo: {
            ...getSnapshot(self.locationInfo),
            supportedCountryAccount:
              tutor_data?.paymentInfo?.country ||
              tutor_data.personalInfo?.locationCountry,
            state: tutor_data.personalInfo?.state,
            country:
              tutor_data.personalInfo?.locationCountry ||
              tutor_data.personalInfo.country,
            region: tutor_data.personalInfo?.region,
            vicinity: tutor_data.personalInfo?.vicinity,
            address: tutor_data.personalInfo?.address,
            latitude: tutor_data.personalInfo?.latitude,
            longitude: tutor_data.personalInfo?.longitude,
            countries,
            regions,
            countriesSupported: supportedCountries,
            lessonType:
              tutor_data.availability?.lessonType ||
              tutor_data.availability?.preferredLessonType,
            exemptedAreas: tutor_data?.availability?.exemptedAreas,
          },
          slug: tutor_data.slug,
        });
      }
      if (key === CLIENT_PAGES.CREDENTIALS) {
        let { staticData, tutorInfo } = data;
        let { regions, countries, educationData } = staticData;
        applySnapshot(self, {
          locationInfo: {
            countries,
            regions,
          },
          educationWorkHistory: tutorInfo.educationWorkHistory,
        });
        self.educationWorkHistory.updateEducationData(educationData);
      }
      if (key === CLIENT_PAGES.EDUCATION_HISTORY) {
        let { staticData, tutorInfo } = data;
        let { regions, countries, educationData } = staticData;
        applySnapshot(self, {
          locationInfo: {
            countries,
            regions,
          },
          educationWorkHistory: tutorInfo.educationWorkHistory,
        });
        self.educationWorkHistory.updateEducationData(educationData);
      }
      if (key === CLIENT_PAGES.WORK_HISTORY) {
        let { tutorInfo } = data;
        applySnapshot(self, {
          educationWorkHistory: tutorInfo.educationWorkHistory,
        });
      }
      if (key === CLIENT_PAGES.TEACHING_PROFILE) {
        let { tutorInfo } = data;
        applySnapshot(self, {
          teachingProfile: tutorInfo.teachingProfile,
        });
      }
      if (key === CLIENT_PAGES.PROFILE_PHOTO) {
        let { tutorInfo: tutor_data } = data;
        applySnapshot(self, {
          personalInfo: {
            ...tutor_data.personalInfo,
            nationality: tutor_data.personalInfo?.country,
            subscription: tutor_data?.appData?.receiveJobs || undefined,
          },
          locationInfo: {
            state: tutor_data.personalInfo?.state,
            country: tutor_data.personalInfo?.locationCountry,
            region: tutor_data.personalInfo?.region,
            vicinity: tutor_data.personalInfo?.vicinity,
            address: tutor_data.personalInfo?.address,
          },
          identity: tutor_data.identity,
        });
      }
      if (key === CLIENT_PAGES.VERIFICATION) {
        applySnapshot(self, {
          identity: data.tutorInfo.identity,
        });
      }
      // if (key === CLIENT_PAGES.VIDEO)
      if (key === CLIENT_PAGES.GUARANTOR_INFO) {
        applySnapshot(self, {
          educationWorkHistory: data.tutorInfo.educationWorkHistory,
        });
      }
      if (key === CLIENT_PAGES.UPLOAD_PROOF) {
        applySnapshot(self, {
          educationWorkHistory: data.tutorInfo.educationWorkHistory,
        });
        self.educationWorkHistory.initializeUploadStore();
      }
      if (key === CLIENT_PAGES.SCHEDULE_INFO) {
        applySnapshot(self, {
          schedule: data.tutorInfo.availability,
        });
      }
      if (key === CLIENT_PAGES.PAYMENT_INFO) {
        let { staticData, tutorInfo: tutor_data } = data;
        let { supportedCountries } = staticData;
        applySnapshot(self, {
          personalInfo: {
            ...tutor_data.personalInfo,
            nationality: tutor_data.personalInfo?.country,
            subscription: tutor_data?.appData?.receiveJobs || undefined,
          },
          locationInfo: {
            supportedCountryAccount:
              tutor_data?.paymentInfo?.country ||
              tutor_data.personalInfo?.locationCountry ||
              tutor_data.personalInfo?.supportedCountryAccount ||
              tutor_data.personalInfo?.country,
            countriesSupported: supportedCountries,
          },
          paymentInfo: tutor_data?.paymentInfo,
        });
      }
      if (key === CLIENT_PAGES.POST_APPLICATION_1) {
        let { staticData, tutorInfo: tutor_data } = data;
        let { countries, regions, supportedCountries } = staticData;
        applySnapshot(self, {
          personalInfo: {
            ...tutor_data.personalInfo,
            nationality: tutor_data.personalInfo?.country,
            subscription: tutor_data?.appData?.receiveJobs || undefined,
          },
          locationInfo: {
            supportedCountryAccount:
              tutor_data?.paymentInfo?.country ||
              tutor_data.personalInfo?.locationCountry ||
              tutor_data.personalInfo?.supportedCountryAccount ||
              tutor_data.personalInfo?.country,
            countriesSupported: supportedCountries,
            state: tutor_data.personalInfo?.state,
            country:
              tutor_data.personalInfo?.locationCountry ||
              tutor_data.personalInfo.country,
            region: tutor_data.personalInfo?.region,
            vicinity: tutor_data.personalInfo?.vicinity,
            address: tutor_data.personalInfo?.address,
            countries,
            regions,
            lessonType: tutor_data.availability?.lessonType,
            exemptedAreas: tutor_data?.availability?.exemptedAreas,
          },
          paymentInfo: tutor_data?.paymentInfo,
          schedule: tutor_data.availability,
          teachingProfile: tutor_data.teachingProfile,
        });
      }
      if (key === CLIENT_PAGES.VIDEO_SUBMISSION) {
        let { tutorInfo: tutor_data } = data;
        applySnapshot(self, {
          others: tutor_data?.others,
        });
      }
      if (key === CLIENT_PAGES.POST_APPLICATION_2) {
        let { tutorInfo: tutor_data } = data;
        applySnapshot(self, {
          agreement: tutor_data?.agreement,
          others: tutor_data?.others,
          educationWorkHistory: tutor_data.educationWorkHistory,
          emailVerified: tutor_data.email_verified,
        });
      }
      fetchBanksInfo();
    }
    const initializeTutorData = function initializeTutorData(
      data: ResponseType
    ) {
      let {
        staticData,
        tutorInfo: tutor_data,
        subjectData: subject_data,
      } = data;
      let { regions, countries, supportedCountries, educationData, pricing } =
        staticData;
      applySnapshot(self, {
        personalInfo: {
          ...tutor_data.personalInfo,
          nationality: tutor_data.personalInfo?.country,
          subscription: tutor_data?.appData?.receiveJobs || undefined,
        },
        dateSubmitted: tutor_data?.appData?.dateSubmitted || undefined,
        locationInfo: {
          ...getSnapshot(self.locationInfo),
          supportedCountryAccount:
            tutor_data?.paymentInfo?.country ||
            tutor_data.personalInfo?.locationCountry,
          state: tutor_data.personalInfo?.state,
          country:
            tutor_data.personalInfo?.locationCountry ||
            tutor_data.personalInfo.country,
          region: tutor_data.personalInfo?.region,
          vicinity: tutor_data.personalInfo?.vicinity,
          address: tutor_data.personalInfo?.address,
          countries,
          regions,
          countriesSupported: supportedCountries,
          lessonType: tutor_data.availability?.lessonType,
          exemptedAreas: tutor_data?.availability?.exemptedAreas,
        },
        educationWorkHistory: tutor_data.educationWorkHistory,
        schedule: tutor_data.availability,
        agreement: tutor_data.agreement,
        paymentInfo: tutor_data.paymentInfo,
        identity: tutor_data.identity,
        teachingProfile: tutor_data.teachingProfile,
        others: {
          ...(tutor_data.others || {}),
          isDeluxe:
            tutor_data.others?.isDeluxe ||
            tutor_data.level?.toLowerCase() == "deluxe" ||
            false,
          inProbation:
            tutor_data.others?.inProbation ||
            tutor_data.level?.toLowerCase() == "probation" ||
            false,
          premium:
            tutor_data.others?.premium ||
            tutor_data.level?.toLowerCase() == "premium" ||
            false,
        },
        slug: tutor_data.slug,
        currentEditableForm:
          tutor_data?.appData?.currentEditableForm || self.currentEditableForm,
        emailVerified: tutor_data.email_verified,
        currentStep: tutor_data?.appData?.currentStep || self.currentStep,
        factors: pricing || {},
        unique_clients: tutor_data?.unique_clients,
        ratings: tutor_data?.ratings,
      });
      if (subject_data) {
        self.subject.initializeTutorSubjects(subject_data);
      }
      self.educationWorkHistory.updateEducationData(educationData);
      self.educationWorkHistory.initializeUploadStore();
      fetchBanksInfo();
    };

    const fetchBanksInfo = function fetchBanksInfo() {
      if (self.locationInfo.supportedCountryAccount) {
        let record = self.locationInfo.countriesSupported.find(
          (o) => o.name === self.locationInfo.supportedCountryAccount
        );
        if (record) {
          self.paymentInfo.initializeBanksInfo(record.banks.map((o) => o.name));
        }
      }
    };
    const sendEmailVerification = flow(function* sendEmailVerification(
      code?: string
    ) {
      try {
        let response = yield adapter.sendEmailVerification({
          email: self.personalInfo.email,
          code,
        });
        if (response?.verified) {
          self.emailVerified = true;
        }
        return response;
      } catch (error) {
        throw error;
      }
    });
    const personalInfoSubmission = function (formData) {
      self.personalInfo.onFormSubmit(formData);
      let { lessonType, exemptedAreas, ...rest } = self.locationInfo.formValues;
      return {
        ...self.personalInfo.formValues,
        others: getSnapshot(self.others),
        ...rest,
      };
    };

    function locationInfoSubmission(formData: any) {
      // let supportedCountryAccount = formData.supportedCountryAccount;
      self.locationInfo.updateFields(formData);
      self.schedule.setPreferredLessonType(formData.lessonType);
      // fetchBanksInfo();

      return {
        ...self.personalInfo.formValues,
        ...self.locationInfo.formValues,
      };
    }
    function educationWorkSubmission() {
      return self.educationWorkHistory.formValues;
    }
    function subjectSelectionSubmission() {
      return self.subject.formValues.map((o) => o.name);
    }
    function verificationSubmission() {
      return self.identity.formValues();
    }
    function scheduleSubmission(formValues: any) {
      self.schedule.saveData(formValues);
      return self.schedule.formValues;
    }
    function agreementInfoSubmission(formValues) {
      self.agreement.updateFields(formValues);
      return self.agreement.formValues;
    }
    function newDevelopmentSubmission() {
      applySnapshot(self.others, {
        ...getSnapshot(self.others),
        newDevelopment: true,
      });
      return self.others.formValues;
    }
    function paymentInfoSubmission(formData) {
      self.paymentInfo.updateFields(formData);

      return self.paymentInfo.formValues;
    }
    function teachingProfileSubmission() {
      return self.teachingProfile.formValues;
    }
    function videoSummarySubmission(payload: any) {
      let response = { id: payload.public_id, url: payload.secure_url };
      self.others.updateFields(response);
      return { videoSummary: self.others.videoSummary.formValues };
    }
    function emailVerificationSubmission() {
      return { emailVerified: self.emailVerified };
    }
    function postProcessingVerification1({ key, data }) {
      let locationInfo = self.locationInfo.formValues;

      if (key === STEPS.LOCATION_INFO) {
        self.locationInfo.updateFields(data);
        self.schedule.setPreferredLessonType(
          JSON.parse(JSON.stringify(data.lessonType))
        );
        fetchBanksInfo();

        locationInfo = {
          ...self.personalInfo.formValues,
          ...self.locationInfo.formValues,
        };
      }
      if (key === STEPS.SCHEDULE_INFO) {
        self.schedule.saveData(data);
      }
      if (key === STEPS.PAYMENT_INFO) {
        self.paymentInfo.updateFields(data);
      }

      return {
        locationInfo,
        availability: self.schedule.formValues,
        teachingProfile: self.teachingProfile.formValues,
        paymentInfo: self.paymentInfo.formValues,
      };
    }
    function postProcessingVerification2({ key, data }) {
      if (key === STEPS.NEW_DEVELOPMENT) {
        applySnapshot(self.others, {
          ...getSnapshot(self.others),
          newDevelopment: true,
        });
      }
      if (key === STEPS.AGREEMENT_INFO) {
        self.agreement.updateFields(data);
      }

      return {
        educationWorkHistory: self.educationWorkHistory.formValues,
        others: self.others.formValues,
        agreement: self.agreement.formValues,
      };
    }

    const onFormSubmit = flow(function* onFormSubmit(
      formData,
      key,
      nextStep: FormStepType | string
    ) {
      self.loading = true;
      try {
        let options = {
          [STEPS.PERSONAL_INFO]: personalInfoSubmission,
          [STEPS.LOCATION_INFO]: locationInfoSubmission,
          [STEPS.EDUCATION_HISTORY]: educationWorkSubmission,
          [STEPS.WORK_HISTORY]: educationWorkSubmission,
          [STEPS.SUBJECT_SELECTION]: subjectSelectionSubmission,
          [STEPS.VERIFICATION]: verificationSubmission,
          [STEPS.SCHEDULE_INFO]: scheduleSubmission,
          [STEPS.AGREEMENT_INFO]: agreementInfoSubmission,
          [STEPS.NEW_DEVELOPMENT]: newDevelopmentSubmission,
          [STEPS.GUARANTOR_INFO]: educationWorkSubmission,
          [STEPS.PAYMENT_INFO]: paymentInfoSubmission,
          [STEPS.TEACHING_PROFILE]: teachingProfileSubmission,
          [STEPS.VIDEO_SUMMARY]: videoSummarySubmission,
          [STEPS.VERIFY_EMAIL]: emailVerificationSubmission,
          [STEPS.UPLOAD_EDUCATION]: educationWorkSubmission,
          [STEPS.UPLOAD_WORK]: educationWorkSubmission,
          [STEPS.POST_APPLICATION_1]: postProcessingVerification1,
          [STEPS.POST_APPLICATION_2]: postProcessingVerification2,
        };
        let data: any = options[key](formData);
        yield adapter.saveTutorInfo(
          key,
          { ...data, canApply: self.others.canApply },
          self.slug,
          nextStep,
          // self.currentEditableForm,
          self.currentStep
        );
        if (
          [
            STEPS.EDUCATION_HISTORY,
            STEPS.WORK_HISTORY,
            STEPS.GUARANTOR_INFO,
          ].includes(key)
        ) {
          self.educationWorkHistory.resetCanSave();
        }
        if (key === STEPS.LOCATION_INFO) {
          fetchBanksInfo();
        }
        // if (key === STEPS.WORK_HISTORY) {
        //   yield self.subject.fetchTutorSubjects();
        // }
        // if (key === STEPS) {
        //   self.subject.onSubjectSubmit(response);
        // }
        self.loading = false;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    const submitApplication = flow(function* submitApplication(
      currentStep: string
    ) {
      let nextSteps = {
        [APPLICATION_STEPS.APPLY]: APPLICATION_STEPS.SUBJECT,
        [APPLICATION_STEPS.SUBJECT]: APPLICATION_STEPS.VERIFY,
        [APPLICATION_STEPS.VERIFY]: APPLICATION_STEPS.COMPLETE,
        [APPLICATION_STEPS.COMPLETE]: APPLICATION_STEPS.TUTOR_PREFERENCES,
        [APPLICATION_STEPS.TUTOR_PREFERENCES]: APPLICATION_STEPS.TERMS,
        [APPLICATION_STEPS.TERMS]: APPLICATION_STEPS.VERIFIED_TUTOR,
      };
      self.currentStep = nextSteps[currentStep];
      try {
        self.applicationLoading = true;
        let token = yield adapter.saveTutorInfo(
          "lastStep",
          {
            currentStep: self.currentStep,
            canApply: self.others.canApply,
            dateSubmitted: self.dateSubmitted || new Date().toISOString(),
          },
          self.slug,
          self.currentEditableForm,
          self.currentStep
        );
        // self.applicationLoading = false;
        return token;
      } catch (error) {
        self.applicationLoading = false;
        throw error;
      }
    });
    const notifyServerForError = flow(function* notifyServerForError(
      err: Error,
      section?: string
    ) {
      // try {
      //   yield adapter.notifyServerForError(err.message);
      // } catch (e) {
      //   console.log(e);
      // }
    });

    const validateFormStep = flow(function* validateFormStep(formValues, step) {
      if (step === STEPS.PERSONAL_INFO) {
        try {
          self.loading = true;
          yield adapter.validateFormStep(formValues, step);
        } catch (error) {
          self.loading = false;
          console.log(error);
          throw error;
        }
      }
    });
    return {
      validateFormStep,
      onFormSubmit,
      initializeTutorData,
      fetchBanksInfo,
      submitApplication,
      sendEmailVerification,
      onStartApplication() {
        self.others.onBeginApplication();
      },

      toNextPath(path?: string) {
        adapter.toNextPath(path);
      },
      updateLoading(loading: boolean) {
        self.loading = loading;
      },
      initializeForm(form: string) {
        self.currentEditableForm = form;
      },
      setCurrentStep(currentStep: string) {
        self.currentStep = currentStep;
      },
      setEditableForm(key: string) {
        self.currentEditableForm = key;
      },
      setCurrentEditable(activeStep) {
        self.currentEditableForm = activeStep;
      },
      setEditAction(isEdit: boolean, currentIndex?: string) {
        self.isEditAction = isEdit;
        if (currentIndex) {
          self.editIndex = currentIndex;
        }
      },
      initializeClientTutorData,
      notifyServerForError,
      updateTutorInfo(tutor_data: any) {
        applySnapshot(self, {
          personalInfo: {
            ...tutor_data.personalInfo,
          },
          identity: tutor_data.identity,
          others: { ...tutor_data.others, canApply: true },
        });
      },
    };
  });
